import { Component, OnInit, ViewChild } from '@angular/core';
import { NewNicheModalComponent } from "app/new-niche-modal/new-niche-modal.component";
import * as $ from 'jquery';
import 'datatables.net';

@Component({
  selector: 'app-niches',
  templateUrl: './niches.component.html',
  styleUrls: ['./niches.component.scss']
})
export class NichesComponent implements OnInit {
    tableWidget: any;
  @ViewChild('newniche', {static: true}) public newNicheModal: NewNicheModalComponent;

  constructor() { }

  ngOnInit() {
  }

  ngAfterViewInit() {
      this.initDatatable()
  }

  private initDatatable(): void {
      let tableId: any = $('#table');
      this.tableWidget = tableId.DataTable({
          select: true,
          pageLength: 25,
          dom: 'Bfrtip',
      });
      $('.dataTables_length, .dataTables_filter').hide();
      $('.next').css('float', 'right');
  }

  openModal() {
      this.newNicheModal.show();
  }

}
